export const spentAmountValidate = (spentArray,remainingAmount) => {
  const newErrors = {}; 


    spentArray.forEach((spent, index) => {
   
      if (!spent.pyId) {
        newErrors[`spent.${index}.payeeId`] = "Payee Type Is Required!";
      } 
      if (!spent.bnkId) {
        newErrors[`spent.${index}.bankId`] = "Bank Type Is Required!";
      }
      if (!spent.amt) {
        newErrors[`spent.${index}.amount`] = "Spent Amount is Required!";
      } else if(remainingAmount < 0){
          newErrors[`spent.${index}.amount`] = "Spent amount is greater than Net payable amount!";
      }
      if (!spent.refNo) {
        newErrors[`spent.${index}.refNo`] = "Refernce Number is Required!";
      }  
      if (!spent.pmtDt) {
        newErrors[`spent.${index}.paymentDate`] = "Payment Date is Required!";
      }  
      });
    return newErrors;
  };
